<template>
  <!--新增管家app应用-->
  <x-addApplication></x-addApplication>
</template>

<script>
export default {
  name: 'addStewardFun'
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/systemSet/stewardApp/addStewardApp.vue